<template lang="pug">
  app-dialog(v-model="$_show" header="Новый файл" confirm-text="Сохранить" :confirm-disabled="!ready" @confirm="create")
    template(slot="prepend")
      v-tabs.ma-0(v-model="tab" background-color="#F0F0F0" color="#00BCD4" slider-color="#00BCD4" height="42" light centered grow)
        v-tab.text-none Документы
        v-tab.text-none Шаблоны
      
    v-tabs-items(v-model="tab" light)
      v-tab-item(light)
        app-select(v-model="newFile.folder" :items="sortedFolders" item-text="name" label="В какую папку")
      v-tab-item(light)

    app-file-input(v-model="newFile.file" :maxSize="maxSize" :formats="formatsFile")
    v-expand-transition
      app-text-field(v-show="newFile.file" v-model="newFile.name" label="Новое название файла" counter="90")
    app-tags-combobox(v-model="newFile.tags" :items="sortedTags")

</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex'
import { AppDialogToggable } from "@/components"
import Uploader from '@/common/Uploader'

let baseFile = { folder: null, name: null, tags: [], file: null }

export default {
  mixins: [AppDialogToggable, Uploader],

  computed: {
    ...mapState('fileStore', ['path']),
    ...mapGetters('fileStore', ['sortedFolders', 'sortedTags']),

    ready () {
      let fileReady = !!this.newFile.file 
                      && !!this.newFile.name 
                      && this.newFile.name.length <= 90 
                      && this.formatsFile.includes(this.newFile.file.name.substring(this.newFile.file.name.lastIndexOf("."))) 
                      && this.newFile.file.size < this.maxSize
      let specReady = this.tab ? this.newFile.tags.length > 0 : !!this.newFile.folder
      return fileReady && specReady
    },
  },

  methods: {
    ...mapActions('fileStore', ['createDocument', 'createTemplate']),

    $_beforeShow () {
      this.newFile = (this.path.id == null) ? { ...baseFile } : this.path.isTag ? { ...baseFile, tags: [this.path] } : { ...baseFile, folder: this.path }
      this.tab = this.path.isTag ? 1 : 0
    },

    create () {
      let createFile = this.tab ? this.createTemplate : this.createDocument
      let makeFileObj = this.tab ? this.makeTemplateObj : this.makeDocumentObj

      this.$_uploadFile(this.newFile.file).then(name => {
        let fileObj = makeFileObj(name)
        createFile(fileObj)
      })
    },

    makeDocumentObj (documentFileName = '') {
      return {
        documentFileName,
        name: this.newFile.name,
        myTags: this.newFile.tags.map(item => this.makeTagObject(item)),
        myFolder: this.newFile.folder
      }
    },

    makeTemplateObj (templateFileName = '') {
      return {
        templateFileName,
        name: this.newFile.name,
        tagged: this.newFile.tags.map(item => ({ myTag: this.makeTagObject(item) }))
      }
    },

    makeTagObject (tag) {
      return tag instanceof Object ? tag : this.sortedTags.find(x => x.name === tag) || { name: tag }
    }
  },

  data () {
    return {
      newFile: { ...baseFile },
      tab: 0,
      maxSize: 10240000,
      formatsFile: ['.docx', '.xlsx']
    }
  },

  watch: {
    'newFile.file' (val) {
      this.newFile.name = val && val.name
    }
  }
}
</script>